/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import './styles.scss';
import { AIResultsPageProps } from './types';
import backgroundAILight from '../../assets/images/background-ai-light.png';
import backgroundAIDark from '../../assets/images/background-ai-dark.png';
import useColorModeValue from '../../hooks/useColorModeValue';
import AIBetaTag from '../ai-beta-tag';
import { generateID } from '../../base/helper';

const TAIResultsPage: React.FC<AIResultsPageProps> = ({
  id = generateID('clientos-ui-toolkit-ai-results-page'),
  children,
  hasBetaLabel
}) => {
  const backgroundImage = useColorModeValue(
    backgroundAILight,
    backgroundAIDark,
    backgroundAIDark
  );

  return (
    <section
      id={id}
      className={`clientos-ui-toolkit-ai-results-page`}
    >
      {hasBetaLabel && <AIBetaTag />}
      <div
        className="clientos-ui-toolkit-ai-results-page__image-container"
        id={`${id}__image-container`}
        aria-hidden="true"
      >
        <img
          src={backgroundImage}
          id={`${id}__image-container__image`}
          className="clientos-ui-toolkit-ai-results-page__image-container__image"
        />
      </div>
      {children}
    </section>
  );
};

export default memo(TAIResultsPage);
